import { Authority } from "@/shared/security/authority";

const AdminActionsComponent = () => import("@/admin/actions/actions.vue");
const ClientsComponent = () => import("@/admin/client/client.vue");
const JhiDocsComponent = () => import("@/admin/docs/docs.vue");
const JhiConfigurationComponent = () => import("@/admin/configuration/configuration.vue");
const JhiHealthComponent = () => import("@/admin/health/health.vue");
const JhiLogsComponent = () => import("@/admin/logs/logs.vue");
const JhiMetricsComponent = () => import("@/admin/metrics/metrics.vue");

export default [
  {
    path: "/admin/actions",
    name: "Actions",
    component: AdminActionsComponent,
    meta: { authorities: [Authority.ADMIN] }
  },
  {
    path: "/admin/clients",
    name: "Clients",
    component: ClientsComponent,
    meta: { authorities: [Authority.ADMIN] }
  },
  {
    path: "/admin/docs",
    name: "JhiDocsComponent",
    component: JhiDocsComponent,
    meta: { authorities: [Authority.ADMIN] }
  },
  {
    path: "/admin/health",
    name: "JhiHealthComponent",
    component: JhiHealthComponent,
    meta: { authorities: [Authority.ADMIN] }
  },
  {
    path: "/admin/logs",
    name: "JhiLogsComponent",
    component: JhiLogsComponent,
    meta: { authorities: [Authority.ADMIN] }
  },
  {
    path: "/admin/metrics",
    name: "JhiMetricsComponent",
    component: JhiMetricsComponent,
    meta: { authorities: [Authority.ADMIN] }
  },
  {
    path: "/admin/configuration",
    name: "JhiConfigurationComponent",
    component: JhiConfigurationComponent,
    meta: { authorities: [Authority.ADMIN] }
  }
];
